// FIRST import, deliberately: this module calls Sentry.init() as a side effect.
// Import declarations are hoisted, so a plain init() call in this file's body
// would run only after i18n and App had already executed their own top-level
// code — importing first is what actually gets Sentry up first.
import '@/lib/sentry';
// Second: loads immer's MapSet plugin before any store module can run a
// producer that reads a `Set` off a draft. See the module header.
import '@/lib/immer-setup';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import '@/lib/i18n';
import './index.css';
import App from './App.tsx';

createRoot(document.getElementById('root')!, {
    // React 19 exposes these root-level hooks. Routing every class of React
    // error through Sentry here means errors caught by an ErrorBoundary — which
    // React would otherwise swallow without a trace — still reach us.
    onUncaughtError: Sentry.reactErrorHandler(),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
}).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
